import type { FC, ReactNode } from "react";

import { Dialog } from "@jti/ui/components/Dialog";
import { useDeviceBreakpoint } from "@jti/ui/hooks/useDeviceBreakpoint";

import styles from "./QuizModal.module.scss";

export type QuizModalProps = {
  isOpened: boolean;
  onClose: () => void;
  children?: ReactNode;
  accessibilityDialogLabel?: string;
};

export const QuizModal: FC<QuizModalProps> = ({ isOpened, onClose, children, accessibilityDialogLabel }) => {
  const { breakpoint } = useDeviceBreakpoint();

  return (
    <Dialog
      isOpened={isOpened}
      onClose={onClose}
      closable
      ariaLabel={accessibilityDialogLabel}
      role="dialog"
      fullscreen={breakpoint === "mobile"}
      className={styles.quizDialog}
      contentWrapperClassName={styles.quizDialogContentWrapper}
    >
      <div className={styles.content}>{children}</div>
    </Dialog>
  );
};
